/**
 * AddSubscriptionSettingsCtrl controller
 * Add/edit Subscription Settings
 */

import { CONTENT_SET_TYPES, PAYMENT_SYSTEM_TYPES, RENT_LENGTH_TYPES2 } from 'app/core/constants'
import { findIn } from 'app/helpers/entity'
import * as _ from 'lodash-es'
import moment from 'moment/moment'
import { isSectionInvalid } from '../../app/helpers/fn'
import { getFilteredKeys, multiSelectWithAll } from '../common/directives/contentItems/ciHelpers'

AddSubscriptionSettingsCtrl.mixes = [
  'openPopupCtrlMixin'
]

/**
 * AddSubscriptionSettingsCtrl controller
 *
 * @class AddSubscriptionSettingsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:openPopupCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddSubscriptionSettingsCtrl
 */
/* @ngInject */
export default function AddSubscriptionSettingsCtrl (
  $location,
  $scope,
  $state,
  $uibModal,
  $window,
  Amount,
  ChannelSet,
  Currency,
  LiveEventSet,
  ShowSet,
  Subscription,
  VODSet,
  alertLiteSvc,
  alertSvc,
  authSvc,
  ecwid,
  inapp,
  networkCurrencies,
  networkSettings,
  pckg,
  scope,
  subscription
) {
  var vm = this

  vm.qualities = {
    SD: 'SD',
    HD: 'HD',
    FHD: 'Full HD',
    _4K: '4K'
  }

  vm.tabsNames = [
    {
      name: 'General Settings',
      link: 'generalSettings',
      icon: 'far fa-cog'
    }, {
      name: 'Price Settings',
      link: 'priceSettings',
      icon: 'far fa-credit-card'
    }, {
      name: 'Subscription Limitations',
      link: 'subscriptionLimitations',
      icon: 'far fa-cog'
    }, {
      name: 'Conditional Price Settings',
      link: 'conditionPriceSettings',
      icon: 'far fa-tag'
    }, {
      name: 'Content Sets',
      link: 'contentSets',
      icon: 'far fa-film'
    }, {
      name: 'Accessories',
      link: 'accessories',
      icon: 'far fa-toolbox'
    }
  ]

  vm.payment_system_types = PAYMENT_SYSTEM_TYPES

  // init element links

  subscription.currency = subscription.currency ? findIn(networkCurrencies)(subscription.currency) : networkCurrencies[0]

  /**
   * Currencies list
   *
   * @memberof mwApp/packages.controller:AddSubscriptionSettingsCtrl
   * @name vm.currencies
   * @type {models.Currency[]}
   */
  vm.currencies = networkCurrencies || []

  if (subscription.$ecwidSettings) {
    subscription.$ecwidSettings.currency = vm.currencies.find(currency => currency.id === subscription.$ecwidSettings.currency.id)
  }

  vm.networkSettings = networkSettings

  vm.unlimitedLength = null

  /**
   *
   * @type {{[periodName:string]: string}}
   */
  vm.rentLengthTypes = RENT_LENGTH_TYPES2

  vm.SC_ENABLED = window.ENV.APP_SC_ENABLED === 'true'

  vm.deviceLimit = networkSettings.ACTIVATION_DEVICE_LIMIT.value

  /**
   * Has access channel constant
   *
   * @memberOf mwApp/packages.controller:SubscriptionSettingsCtrl
   * @function
   */
  vm.hasAccess = function (access) {
    return authSvc.hasAccess(access)
  }

  if (authSvc.hasEnabledFlag('FEATURE_PARTNERS_ENABLED')) {
    vm.tabsNames.push({
      name: 'Partner Products',
      link: 'partnerProducts',
      icon: 'far fa-suitcase'
    })
  }

  /**
   * Platforms array
   *
   * @memberof mwApp/packages.controller:AddPackageCtrl
   * @type {Object[]}
   */
  vm.platforms = subscription._enhancePlatforms()

  vm.pckgPlatforms = pckg._enhancePlatforms()

  /**
   * Package/Network
   *
   * @memberof mwApp/packages.controller:AddSubscriptionSettingsCtrl
   * @type {models.Network}
   */
  vm.pckg = pckg
  vm.pckg.allowedExclusivePaymentSystems = pckg.allowedExclusivePaymentSystems

  /**
   * Subscription
   *
   * @memberof mwApp/packages.controller:AddSubscriptionSettingsCtrl
   * @type {models.Subscription}
   */
  vm.subscription = subscription
  if (subscription.$isInappSubscription && subscription.$isGuestSubscription) {
    vm.subscriptionMode = 'both'
  } else if (subscription.$isInappSubscription) {
    vm.subscriptionMode = 'inapp'
  } else if (subscription.$isGuestSubscription) {
    vm.subscriptionMode = 'guest'
  } else {
    vm.subscriptionMode = null
  }
  vm.subscription.deviceAmounts = [new Amount({
    amountType: 'EXTRA_DEVICE',
    label: 1,
    name: 1,
    amount: 0
  })].concat(vm.subscription.deviceAmounts)
  vm.cachedFreeContentSets = angular.copy(subscription.freeContentSets)
  vm.cachedPaidContentSets = angular.copy(subscription.paidContentSets)
  vm.showExtraPrices = !!subscription.deviceAmounts.find(device => device.amount > 0)

  if (authSvc.hasEnabledFlag('ECOMMERCE_PROVIDER_ENABLED')) {
    vm.subscription.$ecwidSettings = ecwid
    vm.pckg.$ecwidEnabled = ecwid ? !!ecwid.enabled : false
  }

  vm.multiorgEnabled = vm.pckg.multiorgEnabled

  /**
   * isNew flag
   *
   * @memberof mwApp/packages.controller:AddSubscriptionSettingsCtrl
   * @type {Boolean}
   */
  vm.isNew = subscription._isNew()

  if (vm.isNew) {
    vm.subscription.$amountsCount = 1
  }

  /**
   * Checkbox if prefix is autogenerated
   *
   * @memberof mwApp/packages.controller:AddSubscriptionSettingsCtrl
   * @type {Boolean}
   */
  vm.autoIdentifier = !subscription.identifier

  vm.maxTrialLength = function () {
    if (vm.subscription.$periodType === 'UNLIMITED') {
      return 40000
    }
    const maxDays = vm.subscription.lengthType === 'Days' ? vm.subscription.length : vm.subscription.length * 30
    return vm.subscription.trialLengthType === 'Days' ? maxDays : Math.floor(maxDays / 30)
  }

  vm.invalidPrices = function () {
    if ($scope.form) {
      let formKeys = Object.keys($scope.form)
      formKeys = formKeys.filter(key => key.includes('basePrice') || key.includes('devicePrice') || key.includes('extraPrice') || key.includes('taxPrice'))
      formKeys = formKeys.filter(key => key[key.length - 1] === '2')
      return formKeys.reduce((acc, cur) => acc || $scope.form[cur].$invalid, false)
    }
    return false
  }

  /**
   * Change Publish Now
   *
   * @memberof mwApp/packages.controller:AddSubscriptionSettingsCtrl
   */
  vm.handleChangeTrial = function () {
    vm.subscription.trial = !vm.subscription.trial
    if (vm.subscription.trial && !vm.subscription.trialLength) {
      vm.subscription.trialLength = 1
      vm.subscription.trialLengthType = 'Days'
    }
    $scope.form.$setDirty()
  }

  /**
   * Create/update Subscription
   *
   * @memberof mwApp/packages.controller:AddSubscriptionSettingsCtrl
   */
  vm.submit = function (form) {
    if (form?.$invalid) {
      // const invalidField = document.querySelectorAll('.ng-invalid')[1]
      // $window.scrollBy(0, invalidField.getBoundingClientRect().top - 100)
      return
    }
    const csTypes = Object.keys(CONTENT_SET_TYPES)

    if (!subscription.$promoLabelEnabled) {
      subscription.promoLabel = null
    }

    if (subscription.$periodType === 'DEFAULT') {
      const longAddons = []

      const subscriptionLengthDays = subscription.length * (subscription.lengthType === 'Months' ? 30 : 1)
      for (const sets in subscription.paidContentSets) {
        for (const set of subscription.paidContentSets[sets]) {
          if (set.pricing.rent) {
            const { timeUnit, period } = set.pricing.rent
            const setLengthDays = period * (timeUnit === 'MONTH' ? 30 : 1)
            if (setLengthDays > subscriptionLengthDays && set.pricing.rent.$periodType === 'DEFAULT') {
              longAddons.push(set.name)
            }
            if (!subscription.autoPay) {
              set.pricing.rent.autoPay = false
            }
          }
        }
      }

      if (longAddons.length) {
        const message = 'Add-ons Rent length could not be more than Subscription length. Please, change the Rent length of '
        vm.openPopup(message + longAddons.join(', ') + '.', { type: 'NOTE' })
        return false
      }
    } else if (subscription.$periodType === 'UNLIMITED') {
      for (const sets in subscription.paidContentSets) {
        for (const set of subscription.paidContentSets[sets]) {
          if (set.pricing.rent) {
            if (set.pricing.rent.periodUnlimited) {
              set.pricing.rent.autoPay = false
            }
          }
        }
      }
    }
    subscription.paidContentSets.channelSets.forEach(set => {
      if (set.pricing.rent.rentLengthOverride === false) {
        set.pricing.rent.$periodType = subscription.$periodType
        set.pricing.rent.$dueDate = subscription.$dueDate
        set.pricing.rent.period = subscription.length
        set.pricing.rent.timeUnit = subscription.lengthType === 'Days' ? 'DAY' : 'MONTH'
      }
    })

    /**
     * Preparation for save with Exclusive Payment System Settings (EPSS)
     * Copying EPSS from subscription to add-ons
     **/
    function preparationForSaveWithEPSS () {
      function compareEPSS () {
        const totalAddons = csTypes.reduce((acc, type) => acc + subscription.paidContentSets[type].length, 0)
        if (!totalAddons) return false

        const mapFn = (ps) => ps.paymentSystemType

        const arr1 = vm.subscription.exclusivePaymentSystemSetting?.assignedPaymentSystems.map(mapFn) || []

        const arr2 = vm.subscription.$exclusivePaymentSystemSettingCached?.assignedPaymentSystems.map(mapFn) || []

        return !_.isEqual(_.sortBy(arr1), _.sortBy(arr2))
      }

      if (compareEPSS()) {
        alertSvc.confirm({
          header: 'Apply Payment Service Limitations to Add-ons?',
          text: 'Would you like to apply the selected Payment Service limitations to all included Add-ons?'
        })
          .then(() => {
            for (const type of csTypes) {
              subscription.paidContentSets[type].forEach(addon => {
                const condition = (addon?.$buyEnabled && addon?.pricing?.buy?.paymentMethod === 'PER_SET') ||
                  (addon?.$rentEnabled && addon?.pricing?.rent?.paymentMethod === 'PER_SET') ||
                  type === 'multiSets'
                if (condition) {
                  addon.exclusivePaymentSystemSetting = { assignedPaymentSystems: angular.copy(vm.subscription.exclusivePaymentSystemSetting?.assignedPaymentSystems) }
                }
              })
            }
          })
          .finally(() => { doSave() })
      } else {
        doSave()
      }
    }

    // save subscription
    function doSave () {
      if (vm.subscription.$paidPartnerProducts.length && subscription.$paidPartnerProducts.find((product) => product.monetization.amount === 0)) {
        alertLiteSvc.alertError('Partner Product requires a price')
        return
      }
      vm.setDisable()
      vm.changeUnlimited()
      subscription._save(subscription => {
        subscription.identifier = subscription.identifier && !vm.autoIdentifier
          ? subscription.identifier.toUpperCase()
          : null
        if (subscription.periodUnlimited) {
          subscription.length = 0
          subscription.lengthType = null
        }

        subscription.addFreeContentSets = {}
        subscription.removeFreeContentSets = {}
        subscription.removePaidContentSets = {}
        subscription.addPaidContentSets = {}

        const platforms = []
        vm.platforms.forEach(platform => {
          if (platform.checked) {
            platforms.push(platform.name)
          }
        })
        subscription.platforms = platforms.join(';')

        csTypes.forEach(key => {
          subscription.addFreeContentSets[key] = subscription.freeContentSets[key].filter(fcs => !vm.cachedFreeContentSets[key].find($fcs => $fcs.id === fcs.id))
          subscription.removeFreeContentSets[key] = vm.cachedFreeContentSets[key].filter($fcs => !subscription.freeContentSets[key].find(fcs => $fcs.id === fcs.id))

          subscription.addPaidContentSets[key] = subscription.paidContentSets[key].filter(pcs => !vm.cachedPaidContentSets[key].find($pcs => $pcs.id === pcs.id))
          subscription.removePaidContentSets[key] = vm.cachedPaidContentSets[key].filter($pcs => !subscription.paidContentSets[key].find(pcs => $pcs.id === pcs.id))

          if (subscription.id) {
            subscription.paidContentSets[key] = subscription.paidContentSets[key].filter(pcs => !subscription.addPaidContentSets[key].find(apcs => apcs.id === pcs.id))
          }
        })
      })
        // TODO: revert 430012417b836aa25622f98e77d1679630eb758f
        .then(vm.location(subscription).reload)
        .catch(vm.checkAllIntersections)
        // .then(() => { $window.location.reload(true) })
        .finally(vm.unsetDisable)
    }

    // check if listingType was changed
    if (authSvc.hasEnabledFlag('ECOMMERCE_PROVIDER_ENABLED') && vm.subscription.ecommerceEnabled) {
      vm.subscription.currency = vm.subscription.$ecwidSettings.currency
    }

    vm.checkAllIntersections = function () {
      const types = Object.keys(CONTENT_SET_TYPES)
      Promise.all(types.map(type =>
        Subscription.checkIntersection(type, { networkId: pckg.id, id: subscription.id || 0 }, vm.subscription?.freeContentSets[type] || [], vm.subscription?.paidContentSets[type] || [])))
        .then(data => {
          types.forEach((type, index) => {
            if (vm.subscription.$intersections) {
              vm.subscription.$intersections[type] = data[index]
            }
          })
        })
    }

    if (vm.isNew && subscription.subscriptionType !== 'Subscription' && subscription.deviceAmounts.length > 0) {
      subscription.deviceAmounts.length = 0
    }

    if (subscription.id && ((subscription.$cachedPeriodType === 'DEFAULT' && subscription.$cachedPeriodType !== subscription.$periodType) ||
      (subscription.$cachedAutoPay && subscription.$cachedAutoPay !== subscription.autoPay) ||
      (!subscription.$cachedFree && subscription.free))) {
      if (!subscription.$checkedDC) {
        Subscription.loadDiscountCampaigns(subscription, !subscription.free).then((res) => {
          subscription.$checkedDC = true
          subscription.$discountCampaigns = res
          if (subscription.$discountCampaigns.length) {
            vm.showDiscountCampaignsWarning(preparationForSaveWithEPSS)
          } else {
            preparationForSaveWithEPSS()
          }
        })
      } else {
        if (subscription.$discountCampaigns.length) {
          vm.showDiscountCampaignsWarning(preparationForSaveWithEPSS)
        } else {
          preparationForSaveWithEPSS()
        }
      }
    } else {
      preparationForSaveWithEPSS()
    }
  }

  vm.showDiscountCampaignsWarning = function (callback, deleteError = false) {
    $uibModal.open({
      templateUrl: 'components/packages/popups/subscriptionDiscountCampaignErrorModal.html',
      controller: 'SubscriptionDiscountCampaignErrorModalCtrl as vm',
      windowClass: 'modal-class-conflict',
      backdrop: true,
      animation: false,
      resolve: {
        dc: function () {
          return subscription.$discountCampaigns
        },
        autoPayError: function () {
          return subscription.$cachedAutoPay && subscription.$cachedAutoPay !== subscription.autoPay
        },
        freeError: function () {
          return !subscription.$cachedFree && subscription.$cachedFree !== subscription.free
        },
        periodTypeError: function () {
          return subscription.$cachedPeriodType === 'DEFAULT' && subscription.$cachedPeriodType !== subscription.$periodType
        },
        deleteError: function () {
          return deleteError
        },
        subscription: function () {
          return vm.subscription
        }
      }
    })
      .result
      .then(
        function close () {
          callback()
        },
        function dismiss () {
          vm.unsetDisable()
        })
  }

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }

  /**
   * Delete Subscription
   *
   * @memberof mwApp/packages.controller:AddSubscriptionSettingsCtrl
   */
  vm.delete = function () {
    vm.setDisable()
    function deleteSubscription () {
      subscription._delete(null)
        .then(() => {
          setTimeout(() => {
            const cls = subscription.constructor
            const msg = `${subscription.name} ${cls._publicName || cls._name} deleted`
            alertLiteSvc.alertError(msg)
            $location.url(pckg._publicUrl + '/monetization-plans')
          }, 100)
        })
        .finally(vm.unsetDisable)
    }
    Subscription.loadDiscountCampaigns(subscription).then((res) => {
      subscription.$checkedDC = true
      subscription.$discountCampaigns = res
      if (subscription.$discountCampaigns.length) {
        vm.showDiscountCampaignsWarning(deleteSubscription, true)
      } else {
        deleteSubscription()
      }
    })
  }

  /**
   * redirection to 'generalsettings'
   *
   * @memberof mwApp/packages.controller:AddSubscriptionSettingsCtrl
   */
  vm.redirectToSettings = function () {
    vm.multiorgEnabled ? $location.url(`organizations/${vm.pckg.id}#activation_settings`) : $location.url('generalsettings')
  }

  /**
   * Upload logo
   *
   * @memberof mwApp/packages.controller:AddVodCtrl
   * @function
   */
  function uploadLogo (file, type) {
    return subscription._uploadFile(null, file, {
      type
    }).data()
  }

  vm.uploadIcon = (file) => {
    $scope.form.$setDirty()
    const _URL = window.URL || window.webkitURL

    const img = new Image()
    const objectUrl = _URL.createObjectURL(file)
    img.onload = function () {
      _URL.revokeObjectURL(objectUrl)
      if (file.size > 10485760) {
        alertLiteSvc.alertError('File bigger than 10 MB')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      if (this.width * this.height > 16800000) {
        alertLiteSvc.alertError('Max resolution of image is 16.8MPx')
        $scope.$broadcast('dndfile.clear', true)
        return
      }
      return uploadLogo(file, 'cover_subscription')
        .then((url) => {
          vm.subscription.coverImageUrl = url
        }).finally(() => {
          $scope.$broadcast('dndfile.clear', true)
          vm.unsetDisable()
        })
    }
    img.src = objectUrl
  }

  /**
   * Check, if at least one platform is selected
   * @return {Boolean}
   */
  vm.atLeastOnePlatform = function () {
    for (var i = vm.platforms.length; i--;) {
      if (vm.platforms[i].checked) {
        return true
      }
    }
    return false
  }

  /**
   * Redirect to previous page
   *
   * @memberof mwApp/packages.controller:AddVodSetCtrl
   */
  vm.back = function () {
    if (vm.location.canPop()) {
      vm.location.back()
    } else {
      $location.url(vm.pckg._publicUrl + '/monetization-plans')
    }
  }

  vm.recalculate = function () {
    if (vm.invalidPrices()) {
      return
    }
    Subscription.calculate({ ...vm.subscription, baseAmount: { ...vm.subscription.baseAmount, amount: vm.subscription.free ? 0 : (vm.subscription.baseAmount.amount || 0) } }).then(data => {
      vm.subscription.$extraDeviceWithBaseAmounts = data.extraDeviceWithBaseAmounts ? [].concat(data.extraDeviceWithBaseAmounts) : []
      vm.subscription.$subscriptionBasePrice = data.subscriptionBasePrice
    })
  }

  if (!vm.isNew) {
    vm.recalculate()
  }

  vm.decAmount = function (evt, form) {
    evt.stopPropagation()
    evt.preventDefault()
    if (vm.subscription.$amountsCount > 1) {
      form.priceSettings_deviceAmount.$setDirty()
      vm.subscription.$amountsCount--
      subscription.deviceAmounts.pop()
    }
  }

  vm.incAmount = function (evt, form) {
    evt.stopPropagation()
    evt.preventDefault()
    form.priceSettings_deviceAmount.$setDirty()
    vm.subscription.$amountsCount++
  }

  vm.decConcStream = function (evt, form) {
    evt.stopPropagation()
    evt.preventDefault()
    if (vm.subscription.concurrentStreamsLimit > 1) {
      form.num_of_con_stream.$setDirty()
      form.num_of_con_stream.$setTouched()
      vm.subscription.concurrentStreamsLimit--
    }

    if (!vm.subscription.concurrentStreamsLimit && +form.num_of_con_stream.$viewValue > 1) {
      vm.subscription.concurrentStreamsLimit = +form.num_of_con_stream.$viewValue - 1
    }
  }

  vm.incConcStream = function (evt, form) {
    evt.stopPropagation()
    evt.preventDefault()
    form.num_of_con_stream.$setDirty()
    form.num_of_con_stream.$setTouched()
    if (vm.subscription.concurrentStreamsLimit) {
      vm.subscription.concurrentStreamsLimit++
    } else {
      if (form.num_of_con_stream.$viewValue) {
        vm.subscription.concurrentStreamsLimit = +form.num_of_con_stream.$viewValue + 1
      } else {
        vm.subscription.concurrentStreamsLimit = 1
      }
    }
  }

  vm.addExtraAmount = function (evt) {
    evt.stopPropagation()
    evt.preventDefault()
    subscription.deviceAmounts.push(new Amount({
      amountType: 'EXTRA_DEVICE',
      label: subscription.deviceAmounts.length + 1,
      name: subscription.deviceAmounts.length + 1,
      amount: 0
    }))
    vm.recalculate()
  }

  vm.extraAmountPrice = function (evt) {
    evt.stopPropagation()
    evt.preventDefault()
    if (vm.subscription.$amountsCount === 1) {
      vm.subscription.$amountsCount = 2
    }
    for (let i = 0; i < vm.subscription.$amountsCount; i++) {
      if (i + 1 > subscription.deviceAmounts.length) {
        subscription.deviceAmounts.push(new Amount({
          amountType: 'EXTRA_DEVICE',
          label: i + 1,
          name: i + 1,
          amount: 0
        }))
      }
    }
    vm.subscription.$amountsCount = 0
    vm.showExtraPrices = true
    vm.recalculate()
  }

  /**
   * Delete Amount
   *
   * @memberof mwApp/packages.controller:AddSubscriptionSettingsCtrl
   */
  vm.deleteAmount = function (amount) {
    for (var i = subscription.deviceAmounts.length; i--;) {
      if (subscription.deviceAmounts[i] === amount) {
        subscription.deviceAmounts.splice(i, 1)
        if (subscription.deviceAmounts.length === 0) {
          vm.subscription.$amountsCount = 0
          vm.showExtraPrices = false
        }
        vm.recalculate()
        return
      }
    }
  }

  vm.changeUnlimited = function () {
    ['channelSets', 'multiSets'].forEach(type => {
      vm.subscription.paidContentSets[type].forEach(set => {
        if (set?.pricing?.rent && !set.pricing.rent.rentLengthOverride) {
          set.pricing.rent.periodUnlimited = vm.subscription.periodUnlimited
        }
      })
    })
  }

  vm.hasFlag = function (flag) {
    return authSvc.hasEnabledFlag(flag)
  }

  vm.hasCSIntersection = function () {
    if (vm.subscription.$intersections) {
      return Object.keys(vm.subscription.$intersections).reduce((acc, key) => acc || vm.subscription.$intersections[key], false)
    }
    return false
  }

  vm.changeCurrency = function (currency) {
    if (vm.subscription.currency.id === currency.id) return
    if (vm.subscription.assignedAccessories.length) {
      vm.subscription.assignedAccessories.length = 0
      scope.discountSettingsRulesWatcher(vm.subscription.assignedAccessories, 'ACCESSORY')
    }
    vm.subscription.currency = currency
    $scope.form.$setDirty()
  }

  vm.validateSection = isSectionInvalid

  const changeHandler = (form) => {
    form.priceSettings_to.$setTouched()
    const toActual = new Date(vm.subscription.$dueDate?.setHours(23, 59, 59, 999))
    const minError = vm.dpCfg.minDate > toActual
    form.priceSettings_to.$setValidity('min', !minError)
    if (form.priceSettings_to.$valid) {
      ['channelSets', 'multiSets'].forEach(type => {
        vm.subscription.paidContentSets[type].forEach(set => {
          if (!set.pricing.rent.rentLengthOverride) {
            set.pricing.rent.$periodType = 'DUE_DATE'
            set.pricing.rent.$dueDate = vm.subscription.$dueDate
          }
        })
      })
    }
  }

  /**
   * Datepicker default settings
   *
   * @memberof mwApp/reports.controller:AddSubscriptionSettingsCtrl
   * @type {{format : string}}
   */
  vm.dpCfg = {
    format: 'dd.MM.yyyy',
    minDate: moment().endOf('day').toDate(),
    changeHandler: changeHandler
  }

  /**
   * Handle open datepicker
   *
   * @memberof mwApp/reports.controller:AddSubscriptionSettingsCtrl
   */
  vm.open = function () {
    vm.dpCfg.opened = true
  }

  vm.showMessage = function () {
    switch (vm.subscriptionMode) {
      case 'both':
        return 'Subscription used for Guest Mode and In-App Registration cannot have a Due Date'
      case 'guest':
        return 'Subscription used for Guest Mode cannot have a Due Date'
      case 'inapp':
        return 'Subscription used for In-App Registration cannot have a Due Date'
      default:
        return ''
    }
  }

  vm.changeLength = function () {
    if (vm.subscription.length) {
      ['channelSets', 'multiSets'].forEach(type => {
        vm.subscription.paidContentSets[type].forEach(set => {
          if (!set.pricing.rent.rentLengthOverride) {
            set.pricing.rent.period = vm.subscription.length
          }
        })
      })
    }
  }

  vm.changePeriodType = function () {
    ['channelSets', 'multiSets'].forEach(type => {
      vm.subscription.paidContentSets[type].forEach(set => {
        if (!set.pricing.rent.rentLengthOverride) {
          set.pricing.rent.timeUnit = vm.subscription.lengthType === 'Days' ? 'DAY' : 'MONTH'
        }
      })
    })
  }

  vm.disableLabel = function (condition) {
    if (condition) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  vm.getKeys = function (obj) {
    return Object.keys(obj)
  }

  vm.changePlatforms = function () {
    if (vm.notMobilePlatformChecked()) {
      vm.subscription.allowCellularOnly = false
    }
  }

  vm.notMobilePlatformChecked = function () {
    return (vm.subscription.useNetworkPlatforms ? vm.pckgPlatforms : vm.platforms).some(p => {
      return !['IOS', 'ANDROID'].includes(p.value) && p.checked
    })
  }

  vm.multiSelectWithAll = multiSelectWithAll
  vm.getFilteredKeys = getFilteredKeys

  $scope.$watch('vm.subscription.useNetworkPlatforms', () => {
    if (vm.notMobilePlatformChecked()) {
      vm.subscription.allowCellularOnly = false
    }
  })

  $scope.$watch('vm.subscription.autoPay', () => {
    if (vm.subscription.paidContentSets) {
      ['channelSets', 'multiSets'].forEach(type => {
        vm.subscription.paidContentSets[type].forEach(cs => {
          if (!vm.subscription.autoPay && !vm.subscription.periodUnlimited) {
            cs.pricing.rent.autoPay = false
          }
          if (vm.subscription.periodUnlimited && !cs.pricing.rent.rentLengthOverride) {
            cs.pricing.rent.autoPay = false
          }
        })
      })
    }
  })

  $scope.$watch('vm.subscription.periodUnlimited', () => {
    if (vm.subscription.paidContentSets) {
      ['channelSets', 'multiSets'].forEach(type => {
        vm.subscription.paidContentSets[type].forEach(cs => {
          if (!vm.subscription.periodUnlimited && !vm.subscription.autoPay) {
            cs.pricing.rent.autoPay = false
          }
          if (vm.subscription.periodUnlimited && !cs.pricing.rent.rentLengthOverride) {
            cs.pricing.rent.autoPay = false
          }
        })
      })
    }
  })

  $scope.$watch('vm.subscription.$periodType', (newVal, oldVal) => {
    if (oldVal) {
      if (vm.subscription.$periodType === 'DUE_DATE') {
        vm.subscription.autoPay = false
        vm.subscription.trial = false
        // vm.handleChangeTrial()
      }
      ['channelSets', 'multiSets'].forEach(type => {
        vm.subscription.paidContentSets[type].forEach(set => {
          if (!set.pricing.rent.rentLengthOverride) {
            if (vm.subscription.$periodType === 'DUE_DATE') {
              set.pricing.rent.$periodType = vm.subscription.$periodType
              set.pricing.rent.dueDate = vm.subscription.dueDate
              set.pricing.rent.$dueDate = vm.subscription.$dueDate
              set.pricing.rent.period = 0
              set.pricing.rent.timeUnit = null
            } else {
              set.pricing.rent.dueDate = null
            }
            if (vm.subscription.$periodType === 'DEFAULT') {
              set.pricing.rent.$periodType = vm.subscription.$periodType
              set.pricing.rent.period = vm.subscription.length
              set.pricing.rent.timeUnit = vm.subscription.lengthType === 'Days' ? 'DAY' : 'MONTH'
            }
          }
        })
      })
    }
    subscription._setSubscriptionPeriodType()
  })

  $scope.$on('$viewContentLoaded', function () {
    const navbar = document.getElementById('main-nav')
    const navPos = navbar.getBoundingClientRect().top
    const navbarLinks = document.querySelectorAll('.nav li a')

    window.addEventListener('scroll', () => {
      const scrollPos = window.scrollY
      if (scrollPos > navPos) {
        navbar.classList.add('white-bg')
      } else {
        navbar.classList.remove('white-bg')
      }

      if (navbarLinks.length > 1) {
        navbarLinks.forEach(link => {
          const section = document.querySelector(link.hash)

          if (scrollPos + 150 > section?.offsetTop && scrollPos + 150 < section?.offsetTop + section?.offsetHeight) {
            link.parentNode.classList.add('active')
          } else {
            link.parentNode.classList.remove('active')
          }
        })
      }
    })
  })
}
